import _ from 'lodash'
import formatValue, { shortenedAndUnshortened }  from 'scoreboard/components/format-value'
import calendars from 'scoreboard/components/calendars'

function formatScore(score, formatParams) {
	if (!score) {
		return null
	}

	var clone = _.cloneDeep(score)
	formatParams = formatParams || {}

	// actual
	formatParams.value = clone.actual
	clone.actual = shortenedAndUnshortened(formatParams)

	// thresholds
	clone.thresholds = _.map(clone.thresholds, function(threshold) {
		formatParams.value = threshold
		return shortenedAndUnshortened(formatParams)
	})

	// score
	// #32434 score should always use default decimal precision
	clone.score = formatValue({
		value: clone.score,
		dataType: 'score'
	})

	// period
	clone.periodLabel = calendars.periodsById[clone.periodId].label

	return clone
}

export default formatScore


formatScore.__filename__ = 'scorecards/overview/format-score.js'
